import React, { useState } from "react";
import { Button, Spin, message, Alert } from "antd";
import { updateException } from "../api";
import { ExceptionStatus } from "../ExceptionDrawer";
import Hide from "../../components/Hide";

const PackageContractComponent = ({ exception, onClose, onResolved }) => {
    const [loading, setLoading] = useState(false);

    const handleManualResolve = async () => {
        setLoading(true);
        if (exception.status === 'pending') {
            try {
                await updateException(exception.id);
                message.success('Exception marked as resolved');
                try { 
                    if (typeof onResolved === 'function') await onResolved(); 
                } catch {}
                onClose();
            } catch (error) {
                message.error('Failed to resolve exception');
            } finally {
                setLoading(false);
            }
        } else {
            console.warn("Exception already resolved.");
            try { 
                if (typeof onResolved === 'function') await onResolved(); 
            } catch {}
            onClose();
        }
    };

    return (
        <div style={{ marginTop: 20 }}>
            <Hide condition={exception.status === ExceptionStatus.RESOLVED}>
                <Spin spinning={loading} tip="Processing...">
                    <Alert
                        message="Contract Information Required"
                        description={
                            <div>
                                <p>
                                    This exception indicates that contract information is missing for the package. 
                                    Please follow these steps to resolve:
                                </p>
                                <ol style={{ marginLeft: 20, marginTop: 10 }}>
                                    <li>Go to the KoboToolbox form</li>
                                    <li>Add the missing contract information</li>
                                    <li>Ensure all required contract details are completed</li>
                                </ol>
                                <p style={{ marginTop: 15, fontWeight: 'bold' }}>
                                    Once you've updated the contract information in KoboToolbox, 
                                    you can manually mark this exception as resolved.
                                </p>
                            </div>
                        }
                        type="info"
                        showIcon
                        style={{ marginBottom: 20 }}
                    />
                    
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            type="primary"
                            size="large"
                            onClick={handleManualResolve}
                            disabled={loading}
                            loading={loading}
                            style={{ minWidth: 200 }}
                        >
                            Mark Exception as Resolved
                        </Button>
                    </div>
                    
                    <div style={{ 
                        marginTop: 20, 
                        padding: 15, 
                        backgroundColor: '#f6f8fa', 
                        borderRadius: 6,
                        border: '1px solid #e1e4e8'
                    }}>
                        <p style={{ margin: 0, fontSize: 12, color: '#586069' }}>
                            <strong>Note:</strong> This button manually resolves the exception. 
                            Only use it after you have confirmed that the contract information 
                            has been properly added to KoboToolbox.
                        </p>
                    </div>
                </Spin>
            </Hide>
        </div>
    );
};

export default PackageContractComponent;
